import React, { useContext } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import { Button, Form, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { createPrivilege } from "../../redux/slices/privileges";
import NotyfContext from "../../contexts/NotyfContext";

const NewPrivilegeModal = ({
  showNewPrivilegeModal,
  setShowNewPrivilegeModal,
}) => {
  const whitelabel = useSelector((state) => state.whitelabel.whitelabel);
  const dispatch = useDispatch();
  const notyf = useContext(NotyfContext);
  const initialValues = {
    name: "",
  };

  const validation = Yup.object({
    name: Yup.string().required("Name is required"),
  });
  return (
    <Modal
      show={showNewPrivilegeModal}
      onHide={() => setShowNewPrivilegeModal(false)}
      size="md"
      centered
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title>New Privilege</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Formik
          initialValues={initialValues}
          validationSchema={validation}
          onSubmit={async (values, { setValues }) => {
            await dispatch(createPrivilege({ data: values }))
              .then(() => {
                notyf.open({
                  type: "success",
                  message: "Privilege created successfully",
                  duration: 5000,
                  dismissible: false,
                  ripple: true,
                  position: {
                    x: "center",
                    y: "top",
                  },
                });
              })
              .catch((error) => {
                notyf.open({
                  type: "danger",
                  message: error,
                  duration: 5000,
                  dismissible: false,
                  ripple: true,
                  position: {
                    x: "center",
                    y: "top",
                  },
                });
              })
              .finally(() => {
                setValues(initialValues);
                setShowNewPrivilegeModal(false);
              });
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
          }) => {
            return (
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.name}
                    isInvalid={touched.name && errors.name}
                  />
                  {!!touched.name && (
                    <Form.Control.Feedback type="invalid">
                      {errors.name}
                    </Form.Control.Feedback>
                  )}
                </Form.Group>
                <Modal.Footer>
                  <Button
                    variant="secondary"
                    className="me-2"
                    onClick={() => setShowNewPrivilegeModal(false)}
                    style={{
                      "--dynamic-bg-color":
                        whitelabel?.backgroundColor ?? "#0E1A2B",
                      "--dynamic-font-color":
                        whitelabel?.fontColor ?? "#ffffff",
                      border: "none",
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="primary"
                    type="submit"
                    style={{
                      "--dynamic-bg-color":
                        whitelabel?.backgroundColor ?? "#0E1A2B",
                      "--dynamic-font-color":
                        whitelabel?.fontColor ?? "#ffffff",
                      border: "none",
                    }}
                  >
                    Submit
                  </Button>
                </Modal.Footer>
              </Form>
            );
          }}
        </Formik>
      </Modal.Body>
    </Modal>
  );
};

export default NewPrivilegeModal;
